import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchLotes } from '../api/lotes.api';
import { onlyCampoLotes } from '../utils/lote-uso';
import { useRanchoStore } from '../store/rancho.store';

/**
 * Lotes del rancho activo (null = todos). La queryKey incluye el rancho para
 * que los selectores de lote recarguen al cambiar el dropdown "Rancho" del TopBar.
 * `selection` (opcional): si el lote elegido deja de pertenecer al rancho activo, se llama `reset`.
 */
export function useRanchoLotes(
  enabled = true,
  selection?: { value: string; reset: () => void },
  /** Rancho elegido dentro de un diálogo (#59): si se pasa (aunque sea ''), filtra por él
   * en lugar de por el rancho activo del TopBar; '' = todos. */
  ranchoOverride?: string,
  /** true = excluye lotes ADMINISTRATIVO (módulos operativos de Campo). */
  campoOnly = false,
) {
  const storeRanchoId = useRanchoStore((s) => s.activeRanchoId);
  const activeRanchoId = ranchoOverride !== undefined ? (ranchoOverride || null) : storeRanchoId;
  const query = useQuery({
    queryKey: ['lotes', activeRanchoId],
    queryFn: () => fetchLotes(activeRanchoId),
    enabled,
  });
  const all = query.data ?? [];
  const lotes = campoOnly ? onlyCampoLotes(all) : all;
  const value = selection?.value;
  const reset = selection?.reset;
  useEffect(() => {
    if (value && reset && query.isSuccess && !lotes.some((l) => l.loteId === value)) reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, query.data, query.isSuccess]);
  return { ...query, lotes, activeRanchoId };
}
